import { Cart } from '../../../Cart/Cart';
import { Totals as CartTotals } from '../../../Cart/components/Totals';
import { centsToMoney } from '../../../utils/centsToMoney';
import { OrderFieldsFragment } from '../../graphql';

export type TotalsProps = Pick<
	OrderFieldsFragment,
	'total' | 'subTotal' | 'taxAmount'
>;

export const Totals: React.FC<TotalsProps> = ({
	total,
	subTotal,
	taxAmount
}) => (
	<div className="order-totals">
		<Cart>
			<CartTotals
				subTotal={centsToMoney(subTotal)}
				taxAmount={centsToMoney(taxAmount)}
				total={centsToMoney(total)}
			/>
		</Cart>
	</div>
);
